<template>
    <div class="modal-wrap" v-if="showModal">
        <div class="modal">
            <div class="m-body">
                <img v-if="needPic" src="../assets/images/pop-pic.png">
                <div class="msg">{{ msg }}</div>
            </div>
            <div class="m-footer">
                <a href="javascript:" class="btn btn-secondary" @click="confirmModal">确定</a>
                <a href="javascript:" class="btn btn-primary" v-if="needCancel" @click="cancelModal">想一想</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modal",
        props: {
            showModal: Boolean,
            needPic: {
                type: Boolean,
                default: true
            },
            msg: String,
            needCancel: Boolean,
        },
        methods: {
            confirmModal() {
                this.$emit('confirmModal')
            },
            cancelModal() {
                this.$emit('cancelModal')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-wrap {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(2, 9, 37, .5);
        z-index: 100;
        .modal {
            width: 648px;
            border-radius: 6px;
            background: #fff;
            overflow: hidden;
            .m-body {
                padding: 50px;
                text-align: center;
                font-size: 16px;
                color: #666;
                img {
                    margin: 0 auto 10px;
                }
            }
            .m-footer {
                height: 115px;
                background: #f1f1f1;
                display: flex;
                align-items: center;
                justify-content: center;
                .btn {
                    height: 46px;
                    line-height: 46px;
                    font-size: 16px;
                    padding: 0 44px;
                    border-radius: 46px;
                    margin: 0 12px;
                    &.btn-primary {
                        background: #009ef6;
                        color: #fff;
                    }
                    &.btn-secondary {
                        border: 1px solid #009ef6;
                        color: #009ef6;
                    }
                }
            }
        }
    }
</style>
